//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script = {
  name: "OtpInput",
  props: {
    id: {
      type: String,
      default: "otp"
    },
    digits: {
      type: Number,
      default: 5
    },
    mode: {
      type: String,
      default: "separate"
    },
    type: {
      type: String,
      default: "number"
    },
    placeholder: {
      type: String,
      default: "-"
    },
    radius: {
      type: Number,
      default: 5
    },
    gap: {
      type: Number,
      default: 10
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isValid: {
      type: Boolean,
      default: true
    },
    rtl: {
      type: Boolean,
      default: false
    },
    autoFocus: {
      type: Boolean,
      default: true
    },
    errorClass: {
      type: String,
      default: ""
    },
    separateInputClass: {
      type: String,
      default: ""
    },
    separateWrapperClass: {
      type: String,
      default: ""
    },
    groupInputClass: {
      type: String,
      default: ""
    },
    groupWrapperClass: {
      type: String,
      default: ""
    },
    activeInputClass: {
      type: String,
      default: ""
    },
    activeWrapperClass: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      inputValue: [],
      joinedValue: "",
      isInputFocused: false,
      activeInput: -1
    };
  },

  mounted() {
    if (this.autoFocus && !this.isDisabled) {
      this.onFocus(0);
      this.$refs.digitInput[0].focus(); //setting input type based on the existing types for now

      const types = ["text", "password", "number"];

      if (types.indexOf(this.type) != -1) {
        for (let box of this.$refs.digitInput) {
          box.type = this.type;
        }
      }
    }
  },

  computed: {
    wrapperStyle() {
      const dir = this.rtl ? "rtl" : "ltr";
      const styles = {
        direction: dir,
        gap: `${this.gap}px`,
        "border-radius": `${this.radius}px`
      };
      return styles;
    },

    inputStyle() {
      return {
        "--border-radius": `${this.radius}px`
      };
    },

    inputClassHandler() {
      if (this.mode === "separate") {
        if (this.isValid) {
          return this.separateInputClass ? this.separateInputClass : "defualt-input-separate";
        } else {
          return this.separateInputClass ? this.separateInputClass : "defualt-error-input-separate";
        }
      }

      if (this.mode === "group") {
        return this.groupInputClass ? this.groupInputClass : "defualt-input-group";
      }

      return "";
    },

    activeInputClassHandler() {
      if (this.mode === "separate") {
        return this.activeInputClass ? this.activeInputClass : "defualt-active-input";
      }

      return "";
    },

    activeWrapperClassHandler() {
      if (this.mode === "group") {
        if (this.isValid) {
          return this.activeWrapperClass ? this.activeWrapperClass : "defualt-active-wrapper";
        } else {
          return this.activeWrapperClass ? this.activeWrapperClass : "defualt-error-wrapper-group";
        }
      }

      return "";
    },

    wrapperClassHandler() {
      if (this.mode === "separate") {
        return this.separateWrapperClass ? this.separateWrapperClass : "defualt-wrapper-separate";
      }

      if (this.mode === "group") {
        if (this.isValid) {
          return this.groupWrapperClass ? this.groupWrapperClass : "defualt-wrapper-group";
        } else {
          return this.groupWrapperClass ? this.groupWrapperClass : "defualt-error-wrapper-group";
        }
      }

      return "";
    },

    errorClassHandler() {
      return this.errorClass ? this.errorClass : "default-error-class";
    }

  },
  methods: {
    keydownHandler(index, e) {
      if (e.keyCode === 8 && e.target.value === "") {
        this.$refs.digitInput[Math.max(0, index - 1)].focus();
      }
    },

    onInput(index) {
      const [first, ...rest] = this.type === "number" ? this.inputValue[index].replace(/[^0-9]/g, "") : this.inputValue[index];
      this.inputValue[index] = first === null || first === undefined ? "" : first;
      const lastInputBox = index === this.digits - 1;
      const insertedContent = first !== undefined;

      if (insertedContent && !lastInputBox) {
        this.$refs.digitInput[index + 1].focus();
        this.$refs.digitInput[index + 1].value = rest.join("");
        this.$refs.digitInput[index + 1].dispatchEvent(new Event("input"));
      }

      this.joinedValue = this.inputValue.map(value => value).join("");
      this.$emit("value", this.joinedValue);

      if (this.joinedValue.length === this.digits) {
        this.onComplete(this.joinedValue);
      }
    },

    onFocus(index) {
      this.activeInput = index;
      this.isInputFocused = true;
    },

    onBlur() {
      this.activeInput = -1;
      this.isInputFocused = false;
    },

    onComplete(joinedValue) {
      this.onBlur();
      this.$refs.digitInput[this.digits - 1].blur();

      if (this.type === "password") {
        this.$emit("on-complete", joinedValue);
      } else this.$emit("on-complete", joinedValue);
    },

    onChanged(index) {
      this.$emit("on-changed", this.inputValue[index]);
    },

    OnPaste(event) {
      this.$emit("on-paste", event);
    }

  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "vue-otp-input"
  }, [_c('div', {
    staticClass: "otp-wrapper",
    class: _vm.isInputFocused ? _vm.activeWrapperClassHandler : _vm.wrapperClassHandler,
    style: _vm.wrapperStyle,
    attrs: {
      "id": _vm.id
    }
  }, _vm._l(_vm.digits, function (digitInput, index) {
    return _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.inputValue[index],
        expression: "inputValue[index]"
      }],
      key: _vm.id + index,
      ref: "digitInput",
      refInFor: true,
      staticClass: "otp-input",
      class: [_vm.inputClassHandler, _vm.activeInput === index ? _vm.activeInputClassHandler : ''],
      style: _vm.inputStyle,
      attrs: {
        "autocomplete": "one-time-code",
        "placeholder": _vm.placeholder,
        "disabled": _vm.isDisabled
      },
      domProps: {
        "value": _vm.inputValue[index]
      },
      on: {
        "focus": function ($event) {
          return _vm.onFocus(index);
        },
        "blur": _vm.onBlur,
        "paste": _vm.OnPaste,
        "input": [function ($event) {
          if ($event.target.composing) {
            return;
          }

          _vm.$set(_vm.inputValue, index, $event.target.value);
        }, function ($event) {
          return _vm.onInput(index, $event);
        }],
        "change": function ($event) {
          return _vm.onChanged(index);
        },
        "keydown": function ($event) {
          return _vm.keydownHandler(index, $event);
        }
      }
    });
  }), 0), _vm._v(" "), !_vm.isValid ? _c('span', {
    class: _vm.errorClassHandler
  }, [_vm._t("errorMessage")], 2) : _vm._e()]);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-5e5c0710_0", {
    source: "div.vue-otp-input[data-v-5e5c0710]{width:max-content}div.vue-otp-input>div.otp-wrapper[data-v-5e5c0710]{direction:var(--direction);text-align:center;display:flex;align-items:center;justify-content:center;transition-property:all;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.3s}div.vue-otp-input>div.otp-wrapper>input.otp-input[data-v-5e5c0710]{transition-property:all;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.3s;border-radius:var(--border-radius)}div.vue-otp-input>div.otp-wrapper>input.otp-input[data-v-5e5c0710]:disabled{background-color:#ececec!important}div.vue-otp-input>div.otp-wrapper>input.defualt-input-separate[data-v-5e5c0710]{text-align:center;font-weight:600;background-color:transparent;border:solid 2px #ececec;width:3rem;height:48px}div.vue-otp-input>div.otp-wrapper>input.defualt-error-input-separate[data-v-5e5c0710]{text-align:center;font-weight:600;background-color:transparent;border:solid 2px #d50000;width:3rem;height:48px}@media only screen and (max-width:600px){div.vue-otp-input>div.otp-wrapper>input.defualt-input-separate[data-v-5e5c0710]{width:2.5rem;height:40px}}div.vue-otp-input>div.defualt-wrapper-separate[data-v-5e5c0710]{background:0 0}div.vue-otp-input>div.defualt-wrapper-group[data-v-5e5c0710]{border:solid 2px #ececec}div.vue-otp-input>div.defualt-error-wrapper-group[data-v-5e5c0710]{border:solid 2px #d50000}div.vue-otp-input>div.otp-wrapper>input.defualt-input-group[data-v-5e5c0710]{background-color:transparent;font-weight:600;border:none;width:3rem;height:48px;text-align:center}@media only screen and (max-width:600px){div.vue-otp-input>div.otp-wrapper>input.defualt-input-group[data-v-5e5c0710]{width:2.5rem;height:40px}}div.vue-otp-input>div.otp-wrapper>input.defualt-active-input[data-v-5e5c0710]{border:solid 2px #525252}div.vue-otp-input>div.defualt-active-wrapper[data-v-5e5c0710]{border:solid 2px #525252}div.vue-otp-input>span.default-error-class[data-v-5e5c0710]{color:#d50000;font-weight:700}input[data-v-5e5c0710]:focus{outline:0}input[data-v-5e5c0710]::-webkit-inner-spin-button,input[data-v-5e5c0710]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number][data-v-5e5c0710]{-moz-appearance:textfield}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__ = "data-v-5e5c0710";
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

var component = __vue_component__;

// Import vue component
// IIFE injects install function into component, allowing component
// to be registered via Vue.use() as well as Vue.component(),

var entry_esm = /*#__PURE__*/(() => {
  // Get component instance
  const installable = component; // Attach install function executed by Vue.use()

  installable.install = Vue => {
    Vue.component('OtpInput', installable);
  };

  return installable;
})(); // It's possible to expose named exports when writing components that can
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = directive;

export { entry_esm as default };
